import Marionette from "../../../shared/marionette-mustache";
import { BaseRelationModel } from "../../../desktop/models/base-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

const template = require<string>("./restricted-eu-base-relation.html");

@backboneViewProperties({
    tagName: "div",
    template
})
export class RestrictedEUBaseRelationView extends Marionette.ItemView<BaseRelationModel> {
    constructor(options?: Backbone.ViewOptions<BaseRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/restricted-eu-base-relation.ts